import {IStateAutoProject} from './AutoProject.types';
export const initializeState:IStateAutoProject = {
    classes: [],
    projectName: '',
    projectDescription: '',
    projectId: -1,
    startedDate: '',
    trainingGoal: -1,
    projectFlowPhase: -1,
    readyImagesCounter: -1,
    messageBoxFlowPhase: -1,
    featureName: '',
    trainingId: -1,
    isTrainingStarted: false,
    showAiAnalysisNameError: false,
    currentBatchGoodCounter: -1,
    snifferBatchGoal: -1
};

export const initializeStateJson = JSON.stringify(initializeState);
